import { BaseEntity } from "@bndes/bndes-ux4/bndes-angular-utils";
import { Estado } from "./estado.model";
import { HistoricoEstado } from "./historico-estado.model";

export class SolicitacaoCancelamentoGarantia extends BaseEntity {
    public cnpjAgenteFinanceiro: string;
	public idOperacaoExterno: string;
	public sistemaRepasse: string;
	public contratoRepasse: number;
    public dataEnvio: Date;
    public dataAprovacao: Date;
    public identificadorCobranca: number;
    public estado: Estado;    
    public ideMotivoSolicitacaoCancelamento: number;
    public comentarioSolicitante: string;
    public dataAprovacaoCancelamento: Date;
    public usuarioEnvioCancelamento: string;
    public saldoFgiNaDataAprovacaoCancelamento:number;
    public valorBaseCalculoMulta:number;
    public valorPercentualMulta: number;
	public historicoEstados: HistoricoEstado[];
}

export class EstadoSolicitacaoCancelamentoGarantia {
    public id: number;
    public nome; string;
}

export class MultaCancelamento  {
    public valorBaseCalculoMulta:number;
    public valorPercentualMulta: number;
}

export const MOTIVO_CANCELAMENTO =[
    {
        codigo: 1,
        nome:"Solicitação do Agente Financeiro"
    },
    {
        codigo: 2,
        nome:"Cancelamento da operação pelo Agente Financeiro",
    },
    {
        codigo: 3,
        nome:"Auditoria Operacional"
    },
    {
        codigo: 4,
        nome:"Vencimento antecipado da operação"
    },
    {
        codigo: 5,
        nome:"Renúncia em razão de sinistro"
    },
    {
        codigo: 6,
        nome:"Outros"
    }
]
